"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HistoricDataRequestType;
(function (HistoricDataRequestType) {
    HistoricDataRequestType["LatestDataRequest"] = "LatestDataRequest";
    HistoricDataRequestType["TimeRangeDataRequest"] = "TimeRangeDataRequest";
    HistoricDataRequestType["AfterTimeDataRequest"] = "AfterTimeDataRequest";
    HistoricDataRequestType["BeforeTimeDataRequest"] = "BeforeTimeDataRequest";
    HistoricDataRequestType["RecordLocationDataRequest"] = "RecordLocationDataRequest";
})(HistoricDataRequestType = exports.HistoricDataRequestType || (exports.HistoricDataRequestType = {}));
var LatestDataRequest = /** @class */ (function () {
    function LatestDataRequest() {
        this.type = HistoricDataRequestType.LatestDataRequest;
    }
    return LatestDataRequest;
}());
exports.LatestDataRequest = LatestDataRequest;
var TimeRangeDataRequest = /** @class */ (function () {
    function TimeRangeDataRequest() {
        this.type = HistoricDataRequestType.TimeRangeDataRequest;
    }
    return TimeRangeDataRequest;
}());
exports.TimeRangeDataRequest = TimeRangeDataRequest;
var AfterTimeDataRequest = /** @class */ (function () {
    function AfterTimeDataRequest() {
        this.type = HistoricDataRequestType.AfterTimeDataRequest;
    }
    return AfterTimeDataRequest;
}());
exports.AfterTimeDataRequest = AfterTimeDataRequest;
var BeforeTimeDataRequest = /** @class */ (function () {
    function BeforeTimeDataRequest() {
        this.type = HistoricDataRequestType.BeforeTimeDataRequest;
    }
    return BeforeTimeDataRequest;
}());
exports.BeforeTimeDataRequest = BeforeTimeDataRequest;
var RecordLocationDataRequest = /** @class */ (function () {
    function RecordLocationDataRequest() {
        this.type = HistoricDataRequestType.RecordLocationDataRequest;
    }
    return RecordLocationDataRequest;
}());
exports.RecordLocationDataRequest = RecordLocationDataRequest;
//# sourceMappingURL=historicDataTypes.js.map


// WEBPACK FOOTER //
// ./src/core/services/data/historicDataTypes.js